import styled from '@emotion/styled';

export const GreyWrapper = styled.div`
  white-space: pre-line;
  color: ${({ theme }) => theme.colors.neutrals.grey3};
`;

export const EmptyListText = styled.div`
  margin-right: ${({ theme }) => theme.spacing(2)};
`;

export const EmptyListWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 32px;
  padding: 16px 24px;
  background-color: ${({ theme }) => theme.colors.neutrals.grey10};
  border-radius: ${({ theme }) => theme.borderRadius.small};

  svg {
    min-width: 40px;
  }

  ${({ theme }) => theme.media.showAt({ to: 2 })`
    margin: 0 24px;
  `};
`;
